import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

interface toastNotification{
    message: string;
    type: string;
}

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    private toastNotification$ = new BehaviorSubject<toastNotification>({message: '', type: ''});
    private showNotification$ = new BehaviorSubject<boolean>(false);
    
    addNotification(notificationDetails: toastNotification){
        this.toastNotification$.next({message: notificationDetails?.message, type: notificationDetails?.type});
        this.showNotification$.next(true);
    }

    resetNotification() {
        this.toastNotification$.next({message: '', type: ''});
        this.showNotification$.next(false);
    }

    getNotificationDetails(){
        return this.toastNotification$.value;
    }

    getShowNotification(){
        return this.showNotification$.asObservable();
    }
}